import { Link } from "react-router-dom";
import { useClassrooms } from "../data/ClassroomContext";
import { isTabletSetupAvailable } from "../data/tabletSetup";
import { Message, ProblemMessage } from "./Status";
import ui from "./ui.module.css";

// Shown instead of Today while there is no class to teach yet: the classes
// could not be read, the teacher is not linked to one, or there is more than
// one and none has been picked yet.

export const ClassChooser = ({ classrooms, onChoose }) => (
  <div className={ui.stack}>
    <h2 className={ui.cardTitle}>Which class are you teaching?</h2>
    <p className={ui.meta}>We'll remember this for next time.</p>
    <ul className={ui.list}>
      {classrooms.map((c) => (
        <li key={c.id}>
          <button
            type="button"
            className={`${ui.button} ${ui.secondary} ${ui.full}`}
            onClick={() => onChoose(c.id)}
          >
            {c.name}
          </button>
        </li>
      ))}
    </ul>
  </div>
);

const ClassroomGate = () => {
  const classes = useClassrooms();

  let body;
  if (classes.status === "error") {
    body = (
      <ProblemMessage
        problem={classes.problem}
        onRetry={classes.retry}
        autoRetrying={classes.autoRetrying}
      />
    );
  } else if (classes.classrooms.length === 0) {
    body = (
      <Message
        title="You're not linked to a class yet"
        actions={
          <>
            <button
              type="button"
              className={`${ui.button} ${ui.secondary}`}
              onClick={classes.retry}
            >
              Check again
            </button>
            {/* School administrators set up tablets without a class of their own. */}
            {isTabletSetupAvailable() && (
              <Link to="/tablets" className={ui.textButton}>
                Set up learner tablet
              </Link>
            )}
          </>
        }
      >
        Ask your school to add you to your class. Your lessons appear here as soon
        as they do. We'll keep checking automatically.
      </Message>
    );
  } else {
    body = <ClassChooser classrooms={classes.classrooms} onChoose={classes.choose} />;
  }

  return (
    <div className={ui.page}>
      <h1 className={ui.title}>Today</h1>
      {body}
    </div>
  );
};

export default ClassroomGate;
